import React, { useRef, useState } from "react";
import { Modal, Table, Button } from "antd";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import "../Pages/CSS/Traitement.css";
import Draggable from "react-draggable";

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};
const formatNumber = (number) => new Intl.NumberFormat("fr-FR").format(number);

const PreviewModal = ({ visible, onCancel, data }) => {
  const columns = [
    { title: "Numéro Doc", dataIndex: "numdoc", key: "numdoc" },
    { title: "Type Doc", dataIndex: "typedoc", key: "typedoc" },
    { title: "Date Doc", dataIndex: "datedoc", key: "datedoc", align: "center", 
      render: (text) => text ? dayjs(text).format("DD/MM/YYYY") : "" 
    },
    { title: "Date Presc.", dataIndex: "datepresc", key: "datepresc", align: "center",
      render: (text) => text ? dayjs(text).format("DD/MM/YYYY") : "" 
    },
    { title: "Code Société", dataIndex: "codesoc", key: "codesoc", align: "center" },
    { title: "Code Prest.", dataIndex: "codeprest", key: "codeprest" },
    { title: "Code Acte", dataIndex: "codeacte", key: "codeacte" },
    { title: "Matri Part", dataIndex: "matripart", key: "matripart", align: "center" },
    { title: "Matricule", dataIndex: "matricule", key: "matricule", align: "center" },
    { title: "Matri Bénéf", dataIndex: "matribenef", key: "matribenef", align: "center" },
    { title: "Code Fourn.", dataIndex: "codefourn", key: "codefourn", align: "center" },
    { title: "Code Presc.", dataIndex: "codepresc", key: "codepresc" },
    { title: "Type Bénéf", dataIndex: "typebenef", key: "typebenef" },
    { title: "Montant Doc", dataIndex: "montdoc", key: "montdoc", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Montant Versé", dataIndex: "montverse", key: "montverse", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Total Charge", dataIndex: "total_charge", key: "total_charge", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Catégorie", dataIndex: "categ", key: "categ" },
    { title: "Nb Article", dataIndex: "nbarticle", key: "nbarticle", align: "center" },
    { title: "Quantité", dataIndex: "qte", key: "qte", align: "center",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "QP Mutuelle", dataIndex: "qpmut", key: "qpmut", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Frais Réels", dataIndex: "freel", key: "freel", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "QP Assur", dataIndex: "qpassur", key: "qpassur", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Ticket", dataIndex: "ticket", key: "ticket", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Frais Exclus", dataIndex: "fexclus", key: "fexclus", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Ajustement", dataIndex: "ajustmt", key: "ajustmt", align: "right",
      render: (text) => text ? formatNumber(parseFloat(text)) : "" 
    },
    { title: "Traité Par", dataIndex: "process_by", key: "process_by", align: "center" },
  ];
  
  

  const exportToExcel = () => {
    // Créer une nouvelle feuille de calcul
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Créer un fichier Excel et le télécharger
    XLSX.writeFile(workbook, "ventilation_data.xlsx");
  };

  

  return (
    <DraggableModal
      title="Preview Ventilation"
      open={visible}
      onCancel={onCancel}
      maskClosable={false}
      footer={[
        <Button key="back" onClick={onCancel}>
          Fermer
        </Button>,
        <Button key="export" className="buttonExport" onClick={exportToExcel}>
          Exporter
        </Button>,
      ]}
      width={1200}
    >
      <Table
        scroll={{
          x: true,
        }}
        className="custom-header1-table"
        style={{ cursor: "pointer", whiteSpace: "nowrap" }}
        bordered
        showSorterTooltip={false}
        columns={columns}
        dataSource={data}
        rowKey="numfact"
        pagination={false}
      />
    </DraggableModal>
  );
};

export default PreviewModal;
